import React from "react";
import { Layout, Col, Row, Tabs } from "antd";
import { URL } from "../00_Nav/url";

// component
import LayoutBreadCrumb from "../00_Nav/layout/layout_bread_crumb";
import SectionTitle from "../../component/section_title";
import OwnerBusiness from "../04_Setting_Tab_Bussiness/owner_business";
// redux

const { Content } = Layout;
const { TabPane } = Tabs;

const SettingTab = () => {
  // -------------------------- VAR --------------------------
  const breadCrumb = [
    { title: "Home", url: URL.home },
    { title: "Setting", url: null },
  ];
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION --------------------------
  // -------------------------- RENDER --------------------------

  const renderBody = () => {
    return (
      <Row
        style={{ marginTop: 30 }}
        justify="end"
        align="middle"
        gutter={[16, 16]}
      >
        <Col lg={24} md={24} sm={24} xs={24}>
          <Tabs defaultActiveKey="1" type="card" size="large">
            <TabPane tab="Business" key="1">
              <OwnerBusiness />
            </TabPane>
            <TabPane tab="Setting" disabled={true} key="2"></TabPane>
          </Tabs>
        </Col>
      </Row>
    );
  };

  // -------------------------- MAIN --------------------------

  return (
    <Layout className="site-layout full">
      <Content className="content page-content">
        <LayoutBreadCrumb data={breadCrumb} />
        {/* <SectionTitle title="Setting" subtitle="" /> */}
        {renderBody()}
      </Content>
    </Layout>
  );
};

export default SettingTab;
